<template lang="pug">
  v-container(class="pa-15")
    v-dialog(v-model='showDialog' max-width='1000')
      v-card
        v-card-title.headline Lista de referidos
        v-card-text
          p {{currentItem.fullName}} tiene {{currentItem.numberOfReferrals}} referidos
          p {{currentItem.fullName}} tiene acumulado {{amount}}
        v-data-table.elevation-1(:headers="headersDetails" :items="referrals" :items-per-page="10")
        v-card-actions
          v-spacer
          v-btn(color="primary" @click="showDialog = false") Cerrar
    h2 Lista de clientes con referidos
    v-progress-linear(v-if="loading" indeterminate="" color="primary")
    v-data-table.elevation-1(:headers="headers" :sort-by="['numberOfReferrals']" :sort-desc="[true]" :items="withdraws" :items-per-page="15")
      template(v-slot:item.actions="{ item }")
        v-btn( icon='' color='primary' @click="openDetaildialog(item)")
          v-icon mdi-eye
</template>

<script>
  import ReferralsCard from '@/components/custom/ReferralsCard'

  export default {
    components: {
      ReferralsCard: ReferralsCard,
    },
    data () {
      return {
        headers: [
          { text: 'Nombre', value: 'fullName' },
          { text: 'Telefono', value: 'phone' },
          { text: 'Email', value: 'email' }, // de notificaciones
          { text: 'Numero de referidos', value: 'numberOfReferrals' },
          { text: 'Acciones', value: 'actions' },
        ],
        headersDetails: [
          { text: 'Nombre', value: 'name' },
          { text: 'Plan', value: 'plan' },
          { text: 'Tipo', value: 'type' },
          { text: 'Estado', value: 'state' },
          { text: 'Recibe comision', value: 'isInPaidPlan' },
          { text: 'Email', value: 'email' },
          { text: 'Telefono', value: 'phone' },
        ],
        withdraws: [],
        currentItem: {},
        loading: false,
        showDialog: false,
        referrals: [],
        amount: 0,
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('referrals/getClientsWithReferrals').then(res => {
        // console.log(res)
        this.loading = false
        if (res) {
          this.withdraws = res
        }
      })
    },
    methods: {
      openDetaildialog (item) {
        const vm = this
        vm.currentItem = item
        // console.log(item)
        this.$store.dispatch('referrals/getReferralsListAndAmount', item.id).then(res => {
          // console.log(res)
          if (res.referrals && res.amount) {
            this.referrals = res.referrals
            this.amount = res.amount
          } else {
            this.referrals = res // viene []
            this.amount = 0
          }
          vm.showDialog = true
        })
      },
    },
  }
</script>
